import React from "react";
import * as s from "./personal-information.module.less"
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import {Divider} from "../divider";
export const PersonalInformation = ({
	name,
	imagePath,
	jobTitle,
	city,
	country,
	email
}) => {
	const emailSplit = email.split("@")
	return (
		<div className={ s.personalInformation }>
			<GatsbyImage
				className={ s.image }
				alt={name}
				durationFadeIn={0}
				fadeIn={false}
				loading={"eager"}
				image={getImage(imagePath)}
			/>
			<div className={ s.data }>
				<h1>{ name }</h1>
				<span>{ jobTitle }</span>
				<span>{ `${city}, ${country}` }</span>
				<span>
					{ emailSplit[0] }
					<span className={ s.mailAt }>@</span>
					{ emailSplit[1] }
				</span>
				<Divider/>
			</div>
		</div>
	)
}
